<script>
import { Doughnut } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';

export default {
  props: [ 'eventCounts' ],
  extends: Doughnut,
  components: { ChartJsPluginDataLabels },
  mounted() {
    this.options = {
      legend: {
        display: false,
        position: 'right'
      },
      plugins: {
        datalabels: {
          display: true,
          font: {
            size: 18
          },
          color: '#FFFFFF'
        }
      }
    };
    this.renderChart(this.chartData, this.options)
  },
  computed: {
    chartData() {
      return {
        //管理画面で設定したイベント
        labels: this.labels,
        datasets: [{
          data: this.counts,
          backgroundColor: this.colors
        }]
      }
    },
    labels() {
      return Object.keys(this.eventCounts)
    },
    counts() {
      return this.labels.map(l => this.eventCounts[l])
    },
    colors() {
      const count = this.labels.length;
      return this.labels.map(function(label, index) {
        let alpha = 1 - (index * (1/count))
        const color = `rgba(0,156,225, ${alpha})`
        return color
      });
    }
  },
  methods: {
  },
  watch : {
    data() {
      this.renderChart(this.chartData, this.options);
    },
    labels() {
      this.renderChart(this.chartData, this.options);
    }
  }
}
</script>
